import { RootState } from 'application/store';

import { DEFAULT_ACCEPTANCE_ADVANCED_ID } from './consts';

export const selectAcceptanceAdvancedState = (state: RootState) => state.acceptanceAdvanced;

export const selectAcceptanceAdvancedById =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId];

export const selectIsAcceptanceAdvancedSigningLoading =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId]?.loading || false;

export const selectAcceptanceAdvancedLink =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId]?.acceptanceAdvancedTabUrl;

export const selectIsAcceptanceAdvancedPolling =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    Boolean(state.globalPolling.activePolls[acceptanceAdvancedId]);
